module.exports = ".grid-container {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./App/Components/grid.component.css
// module id = 565
// module chunks = 1